import Dropdown from '@jetbrains/ring-ui/components/dropdown/dropdown'
import {Directions} from '@jetbrains/ring-ui/components/popup/popup.consts'
import * as React from 'react'

import TransformText from '../../../../../../containers/TransformText'
import {useDistanceToNow} from '../../../../../../hooks/useTimeSelector'
import type {User} from '../../../../../../services/rest'
import Popup from '../../../../../common/Popup/Popup.lazy'
import CommentIcon from '../../EnableAgentForm/CommentIcon/CommentIcon'

import styles from './StatusComment.css'

const POPUP_DIRECTIONS = [
  Directions.BOTTOM_RIGHT,
  Directions.BOTTOM_LEFT,
  Directions.TOP_LEFT,
  Directions.TOP_RIGHT,
]

function StatusComment({
  statusTitle,
  text,
  user,
  timestamp,
  className,
}: {
  statusTitle: string
  text: string
  timestamp?: string | null
  user?: User
  className?: string
}) {
  const userName = (user != null && (user.name != null ? user.name : user.username)) || null
  const anchor = (
    <div className={styles.anchor}>
      <CommentIcon className={styles.icon} />
      <div className={styles.name}>{userName != null ? `${userName}: ` : null}</div>
      <TransformText
        text={text}
        showPlaceholder={false}
        className={styles.transformedComment}
        loaderClassName={styles.transformedComment}
      />
    </div>
  )
  const timestampFromNow = useDistanceToNow(timestamp)

  return (
    <Dropdown
      anchor={anchor}
      hoverHideTimeOut={300}
      clickMode={false}
      hoverMode
      className={className}
    >
      <Popup directions={POPUP_DIRECTIONS} top={4} className={styles.popup}>
        {user != null || timestampFromNow != null ? (
          <div>
            {statusTitle}
            {userName != null && ` by ${userName}`}
            {timestampFromNow != null && ` ${timestampFromNow}`}
          </div>
        ) : null}
        <div>
          {user != null || timestamp != null ? 'with note: ' : null}
          <TransformText TagName="span" text={text} showPlaceholder={false} />
        </div>
      </Popup>
    </Dropdown>
  )
}

export default StatusComment
